import React from 'react';

import GAException from 'src/components/GAException';
import { Box } from 'react-feather';
import { handleGetStorage } from 'src/hooks/validationParticipantes';

handleGetStorage();

const logoWidthMax = JSON.parse(localStorage.getItem('themeConfig'))?.logoWidthMax ? JSON.parse(localStorage.getItem('themeConfig'))?.logoWidthMax : "250px";
const logoWidthMin = JSON.parse(localStorage.getItem('themeConfig'))?.logoWidthMin ? JSON.parse(localStorage.getItem('themeConfig'))?.logoWidthMin : "250px";

function Logo(props) {

  let logoConfig = localStorage.getItem("themeConfig") !== null ? JSON.parse(localStorage.getItem("themeConfig")).loginView.logoUrl : "/static/images/dimo/logo_dimo_white.png";
  
  return (
    <img
      style={{ width: `${props.width ? logoWidthMax : logoWidthMin}` }}
      alt="Logo"
      src={logoConfig}
      {...props}
    />
  );
}

export function LogoDimo(props) {

  let logoConfig = JSON.parse(localStorage.getItem('themeConfig'))?.requiereDarkLogin ? "/static/images/dimo/logo_dimo_blue.png" : "/static/images/dimo/logo_dimo_white.png";

  return (
    <img
      style={{ width: props.width ? props.width : '100px' }}
      alt="Logo"
      src={logoConfig}
      {...props}
    />
  );
}

export function LogoResize(props) {

  let logoConfig = localStorage.getItem("themeConfig") !== null ? JSON.parse(localStorage.getItem("themeConfig")).loginView.logoUrl : "/static/images/dimo/logo_dimo_white.png";

  return (
    <img
      style={props.width ? { width: props.width } : { width: '220px' }}
      alt="Logo"
      src={logoConfig}
      {...props}
    />
  );
}

export function LogoBanderaPya({ tamano, classes }){
  return (
    <img
      src="/static/images/dimo/bandera_paraguaya.png"
      alt="banderaParaguaya"
      height={tamano}
      width={tamano}
      className={classes}
      style={{ marginRight: '5px' }}
    />
  );
}

export function LogoMin(props) {
  return (
    <img
      style={{ width: '50px' }}
      alt="Logo"
      src={"/static/logo_dimo_blue.jpg"}
      {...props}
    />
  );
}

export function LogoBlue(props) {
  let themeConfig = localStorage.getItem("themeConfig");
  let logoConfig = themeConfig
    ? JSON.parse(themeConfig).splashIcon
    : "/static/images/dimo/logo_dimo_white.";

  return (
    <img
      style={{
        width: '100%', // Se adapta al contenedor
        maxWidth: '400px', // Tamaño máximo del logo
        height: 'auto' // Mantiene la proporción
      }}
      alt="Logo"
      src={logoConfig}
      {...props}
    />
  );
}

export function LogoCabal(props) {
  return (
    <img
      style={{ width: '50px' }}
      alt="Logo"
      src={"/static/logo_cabal_vertical.jpg"}
      {...props}
    />
  );
}

export function LogoCabalResize(props) {
  return (
    <img
      className={props.className}
      alt="Logo"
      src={"/static/logo_cabal_vertical.jpg"}
    />
  );
}

export function LogoCabalHorizontal(props) {
  return (
    <img
      style={{ width: '100%' }}
      alt="Logo"
      src={"https://estatico.cabal.coop.py/public/institucional/logos/logo.png"}
      {...props}
    />
  );
}

export function LogoCoop({ logoUrl, ...props }) {
  return (
    <img
      style={{ width: '100%' }}
      alt="Logo"
      src={(logoUrl && logoUrl !== null) ? logoUrl : ""}
      {...props}
    />
  );
}

export function LogoCabalPanal(props) {
  return (
    <img
      style={{ width: '70%', maxWidth:'250px' }}
      alt="Logo"
      src={"https://estatico.cabal.coop.py/public/dimo/cabal_panal.png"}
      {...props}
    />
  );
}

export function LogoSicoopLogin(props) {
  return (
    <img
      style={{ width: '100px' }}
      alt="Logo"
      src={JSON.parse(localStorage.getItem('themeConfig'))?.requiereDarkLogin ? "/static/images/dimo/SICOOP_GRAY.png" : "/static/images/dimo/SICOOP_BLANCO.png"}
      {...props}
    />
  );
}


/**
 * Logos de Dimo
 */

/**
 * 
 * @param {Object} JSON - {isCustom, customStyle, alt, src}
 * @param {Boolean} JSON.isCustom - Si es custom o no
 * @param {Object} JSON.customStyle - Estilo custom
 * @param {String} JSON.alt - Descripción de la imagen
 * @param {String} JSON.src - URL de la imagen
 * @returns {Component} - Componente de imagen 
 */
export function LogoDimoLogin({ isCustom, customStyle, alt, src }) {
  return (
    <img
      style={isCustom ? customStyle : { width: '100%' }}
      alt={isCustom ? alt : "Logo"}
      src={src ? src : "/static/images/dimo/logo_dimo_white.png"}
    />
  );
}


export default Logo;
